// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"245":"dd715ae4","551":"268b17ed"}[chunkId] + ".chunk.css";
};